import {AddNotification} from '../notifications/types'
import {useContext} from 'react'
import {NotificationsContext} from '../notifications/context'

const useAddNotification = (): AddNotification => {
  const addNotification = useContext(NotificationsContext)

  if (addNotification === null) {
    console.error('Make sure to wrap your page in <Notifications> component to use notifications!')
    return () => null
  }

  return addNotification
}

export default useAddNotification
